export const STOCK_TRANSFER_ROUTE_ROOT = '/bin-transfer';

export const STOCK_TRANSFER_ROUTES = {
  STOCK_TRANSFER: STOCK_TRANSFER_ROUTE_ROOT,
  LIST_SOURCE: `${STOCK_TRANSFER_ROUTE_ROOT}/list/source`,
  LIST_DESTINATION: `${STOCK_TRANSFER_ROUTE_ROOT}/list/destination`,
  TASK_SOURCE: `${STOCK_TRANSFER_ROUTE_ROOT}/task/source/:skuId`,
  TASK_DESTINATION: `${STOCK_TRANSFER_ROUTE_ROOT}/task/destination/:skuId`,
  SUMMARY: `${STOCK_TRANSFER_ROUTE_ROOT}/summary`,
} as const;
